import React, {Component} from "react";
import {Col, CustomInput, Input, Row} from "reactstrap";
import {withTranslation} from "react-i18next";
import {debounce} from "lodash";

class LivePagination extends Component {
    constructor(props) {
        super(props);
    }

	triggerFetch = debounce(()=>{
		this.props.setPage(this.props.paginationData.pageNumber)
	},500)

	handlePageInputChange = (event) => {
		this.props.setPage(event.target.value, false)
		this.triggerFetch();
	}

    // Generate pagination buttons
    generatePagination = () => {
        return <div className="datatable__actions">
			<div className="datatable__actions__extras">
				<Row className="flex--align-center">
					<Col xs={6}>Page{' '} <strong>{this.props.paginationData.pageNumber} {this.props.t(`docs.pagination.of`)} {this.props.paginationData.totalPages === 0 ? this.props.paginationData.totalPages+1 : this.props.paginationData.totalPages}</strong></Col>
					<Col xs={6} className="a-right">
						<CustomInput
							type="select"
							value={this.props.paginationData.pageSize}
							id="row-range-select"
							onChange={(event)=>{this.props.setPerPage(event)}}
						>

							{[10, 20, 30, 40, 50].map((pageSize) => (
								<option key={pageSize} value={pageSize}>
									{this.props.t('misc.sorter.show')} {pageSize}
								</option>
							))}
						</CustomInput>

					</Col>
				</Row>
			</div>
			<div className="datatable__actions__base flex flex--justify-center">
				<button className="btn btn--table" onClick={() => {this.props.setPage(1)}} disabled={this.props.paginationData.pageNumber==1}>
					<i className="fas fa-angle-double-left"></i>
				</button>
				<button className="btn btn--table" onClick={() => {this.props.setPage(this.props.paginationData.pageNumber-1)}} disabled={this.props.paginationData.pageNumber==1}>
					<i className="fas fa-angle-left"></i>
				</button>
				<div>
					<Input
						type='number'
						className='input-current-page'
						min={1}
						style={{width: 85}}
						max={this.props.paginationData.totalPages}
						value={this.props.paginationData.pageNumber}
						onChange={(event) => {this.handlePageInputChange(event)}}
					/>

				</div>
				<button className="btn btn--table" onClick={() => {this.props.setPage(this.props.paginationData.pageNumber+1)}} disabled={this.props.paginationData.pageNumber==this.props.paginationData.totalPages}>
					<i className="fas fa-angle-right"></i>
				</button>
				<button className="btn btn--table" onClick={() => {this.props.setPage(this.props.paginationData.totalPages)}} disabled={this.props.paginationData.pageNumber==this.props.paginationData.totalPages}>
					<i className="fas fa-angle-double-right"></i>
				</button>
			</div>
		</div>;
    };

    render() {
        return (
            <React.Fragment>
                {this.generatePagination()}
            </React.Fragment>
        );
    }
}

export default withTranslation()(LivePagination);
